import api from "./api";

/**
 * R6 — Analytics endpoints (SM/Admin only, enforced server-side).
 */
const analyticsService = {
  getRepLeaderboard: (params = {}) => api.getAnalyticsRepLeaderboard(params),
  getSourcePerformance: (params = {}) => api.getAnalyticsSourcePerformance(params),
  getReminderResponsiveness: (params = {}) => api.getAnalyticsReminderResponsiveness(params),
  getStaleLeadsHeatmap: (params = {}) => api.getAnalyticsStaleLeadsHeatmap(params),
  getOverdueHeatmap: (params = {}) => api.getAnalyticsOverdueHeatmap(params),
  getFilters: () => api.getAnalyticsFilters(),
};

export default analyticsService;